//Capitaliza una palabra
export const capitaliceWord = (word) => {
    return (word === null || word === void 0 ? void 0 : word.charAt(0).toUpperCase()) + (word === null || word === void 0 ? void 0 : word.slice(1));
};
export const formatDecimals = (input) => {
    const num = Number(input);
    const codifiedDecimal = num === null || num === void 0 ? void 0 : num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return codifiedDecimal;
};
